"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberOfVehicles = void 0;
const getNumberOfVehicles = (max_pax, number_of_passengers) => {
    let number_of_vehicles = 1;
    number_of_vehicles = Math.ceil(number_of_passengers / max_pax);
    return number_of_vehicles;
};
exports.getNumberOfVehicles = getNumberOfVehicles;
